<template lang="">
  <div
    v-if="$store.state.permissions.usersPage"
    class="flex flex-row w-screen"
  >
    <div class="w-full">
      <div
        class="lg:flex lg:items-center lg:justify-between my-4 lg:mx-12 mx-12"
      >
        <div class="flex justify-center lg:justify-start mt-4 min-w-0">
          <div>
            <h2
              class="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate"
            >
              All Users
            </h2>
          </div>
        </div>
        <div
          class="mt-4 gap-3 w-min flex flex-col justify-center md:flex-row lg:mt-0 lg:ml-4"
        >
          <button
            @click="createUserModal = true"
            class="py-2 px-4 mt-2 mx-2 bg-woo rounded-lg text-white font-semibold"
          >
            Add user
          </button>
        </div>
      </div>

      <GoodTable
        class="w-max"
        :name="'users'"
        :rows="users"
        :columns="columns"
        @editUser="editUser"
      />

      <AddUserModal
        v-if="createUserModal"
        :types="types"
        @addUser="addUser"
        @close="createUserModal = false"
      />
      <EditUserModal
        v-if="editUserModal"
        :userData="userData"
        @putUser="putUser"
        @close="editUserModal = false"
      />
    </div>
  </div>
</template>

<script>
import Http, { OCR_ENDPOINTS } from "../request";
import AddUserModal from "../components/AddUserModal.vue";
import EditUserModal from "../components/EditUserModal.vue";
import GoodTable from "../components/GoodTable.vue";
import moment from "moment";
import store from "../store";
export default {
  created() {
    this.getUsers();
    this.getTypes();
    if (this.$store.state.userType.id == 4) {
      this.columns.push({
        label: "Actions",
        field: "actions",
        sortable: false,
      });
    }
  },

  components: {
    GoodTable,
    AddUserModal,
    EditUserModal,
  },

  data() {
    return {
      userData: {},
      types: [],
      deleteProject: false,
      users: [],
      createUserModal: false,
      editUserModal: false,

      columns: [
        {
          label: "Username",
          field: "username",
        },
        {
          label: "Name",
          field: "name",
        },
        {
          label: "Type",
          field: "type",
        },
        {
          label: "Created By",
          field: "createdBy",
        },
        {
          label: "Creation Date",
          field: "creationDate",
        },
      ],
    };
  },

  methods: {
    putUser(id, name, type) {
      // console.log(id, name, type);
      Http()
        .put(OCR_ENDPOINTS.users, {
          userId: id,
          name: name,
          userType: type,
        })
        .then((response) => {
          let index = this.users.findIndex(function (i) {
            return i.id === id;
          });
          let tempUser = response.data;
          this.modifyNew(tempUser);
          // insert updated user into array
          this.users.splice(index, 0, tempUser);
          // remove old user details from index + 1 (since new user is at index)
          this.users.splice(index + 1, 1);
          this.$toast.success(name + " updated successfully");
          this.editUserModal = false;
        })
        .catch((error) => {
          this.$toast.error(error?.response?.data?.error);
        })
        .finally(() => {});
    },
    editUser(userData) {
      this.userData = userData;

      this.editUserModal = true;
    },

    getTypes() {
      Http()
        .get(OCR_ENDPOINTS.usersTypes)
        .then((response) => {
          this.types = response.data;
        })
        .catch((error) => {
          this.$toast.error(error?.response?.data);
        })
        .finally(() => {});
    },

    addUser(username, name, password, selectedType) {
      Http()
        .post(OCR_ENDPOINTS.users, {
          username: username,
          password: password,
          name: name,
          userType: selectedType,
        })
        .then((response) => {
          this.$toast.success("User added successfully");
          this.createUserModal = false;
          this.newUser = response.data;
          this.modifyNew(this.newUser);
          this.users.unshift(this.newUser);
        })
        .catch((error) => {
          this.$toast.error(error?.response?.data);
        })
        .finally(() => {});
    },
    modifyNew(obj) {
      obj.type = obj.userType.name;
      if (obj.creationAdmin) obj.createdBy = obj.creationAdmin.username;
      obj.creationDate = moment(obj.creationDate).format("YYYY-MM-DD hh:mm a");
    },

    moment: function () {
      return moment();
    },

    modifyData() {
      for (var i = 0; i < this.users.length; i++) {
        this.users[i].creationDate = moment(this.users[i].creationDate).format(
          "YYYY-MM-DD hh:mm a"
        );
        if (this.users[i].creationAdmin)
          this.users[i].createdBy = this.users[i].creationAdmin.username;

        this.users[i].type = this.users[i].userType.name;
      }
    },

    getUsers() {
      Http()
        .get(OCR_ENDPOINTS.users, {
          params: {
            page: 0,
            size: 1000,
          },
          showLoader: true,
        })
        .then((response) => {
          this.users = response.data;
          this.modifyData();
        })
        .finally(() => {
          //
        });
    },

    closeModal() {
      this.deleteProject = false;
    },
  },
};
</script>
<style lang=""></style>
